import {getApiSitePrefix} from "../functions/SiteDefaults";
import axios from "axios";

const apiSitePrefix = getApiSitePrefix();

const getUserMetaData = async (user) => {

  try {
    const response = await axios.get(`${apiSitePrefix}/usermetadata/${user}`);
    if (!response.data) {
      console.log('Could not get the user\'s Meta Data: ');
      return null;
    }
    return response.data;
  } catch (err) {
    console.log('Could not get the user\'s Meta Data: ', err);
    return null
  }
}

const updateUserMetaData = async (user, data) => {
  const metaData = {
    userId: user,
    metaData: data
  }

  try {
    const response = await axios.post(`${apiSitePrefix}/usermetadata`, metaData);
    if (!response.data) {
      console.log('Could not update the user\'s Meta Data: ');
      return null;
    }
    return response.data;
  } catch (err) {
    console.log('Could not update the user\'s Meta Data: ', err);
    return null
  }
}

export {
  getUserMetaData,
  updateUserMetaData,
};